import { Business, Service } from "@turizi/shared";
import { getAttrValue } from "@/lib/models-utils";
import { useTranslation } from "react-i18next";
import { BUSINESSES_PATH, SERVICES_PATH } from "@/lib/navigation";
import { wrapInLink } from "@/lib/draw-utils";
import { IconMoon, IconRoute, IconSun, IconUsers } from "@tabler/icons-react";
import { formatTime } from "@/lib/format-utils";


interface Props {
    service: Service;
    hideProviders?: boolean;
    hideCity?: boolean;
    links?: boolean;
}

export default function TourTitle({
    service,
    hideCity,
    links = false,
}: Props) {
    const { t } = useTranslation();

    const regular = getAttrValue(service, 'regular_schedule');
    // const tour_path = getAttrValue(service, 'tour_path');
    const start_time = getAttrValue(service, 'start_time');
    const end_time = getAttrValue(service, 'end_time');
    const is_nightly = start_time > "18:00";
    const vehicle_type = getAttrValue(service, 'vehicle_type');
    const tour_type = getAttrValue(service, 'tour_type');

    return (
        <div className="space-y-1 w-full text-gray-900">
            {wrapInLink(
                <div className="w-full">
                    <div className="font-medium">
                        {service?.name}
                    </div>

                    {/* Third Row (Pills) are always */}
                    <div className="mt-0.5 flex flex-wrap items-center gap-1 text-[9px]">

                        {vehicle_type && (
                            <div className=" flex items-center gap-1 bg-gray-700 text-white px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
                                {vehicle_type}
                            </div>
                        )}

                        <div className={` px-2.5 py-0.5 rounded-full font-medium whitespace-nowrap 
                            ${regular
                                ? 'bg-green-50 text-green-900/70'
                                : 'bg-orange-50 text-orange-900/70'}`}
                        >
                            {regular ? t('regular_schedule') : t('private')}
                        </div>

                        {(start_time || end_time) ? (
                            <div
                                className={
                                    ` flex items-center gap-1 px-2.5 py-0.5 rounded-full font-medium whitespace-nowrap
                                ${is_nightly
                                        ? 'bg-indigo-50 text-indigo-600'
                                        : 'bg-amber-50 text-amber-600'
                                    }
                            `}>
                                {is_nightly ? <IconMoon size={12} stroke={2.5} /> : <IconSun size={12} stroke={2.5} />}
                                <div>
                                    {start_time && formatTime(start_time)}
                                    {start_time && end_time && ' - '}
                                    {end_time && formatTime(end_time)}
                                </div>
                            </div>
                        ) : (
                            null
                        )}
                        {tour_type && (
                            <div className=" flex items-center gap-1 px-2.5 py-0.5 rounded-full font-medium whitespace-nowrap bg-slate-100 text-slate-700">
                                {tour_type}
                            </div>
                        )}
                        {/* Location Information */}
                        {/* {!hideCity && !!tour_path && (
                            <div className="flex items-center gap-1  font-normal text-gray-500">
                                <span><IconRoute size={12} stroke={1} /></span>
                                <span>{tour_path}</span>
                            </div>
                        )} */}
                        <div className="text-slate-800 font-medium bg-gray-100 rounded-full px-2 py-0.5 flex items-center gap-1">
                            <IconUsers size={10} color="#9ca3af" stroke={2} /> {service.min_pax_per_booking || '0'} <span className="text-gray-400">-</span> {service.max_pax_per_booking || '∞'}
                        </div>
                        <div className="text-slate-500 font-light bg-gray-100 rounded-full px-2 py-0.5">
                            #{service.id}
                        </div>
                    </div>
                </div>,
                links ? `${SERVICES_PATH}/${service.id}` : null)
            }

        </div>
    )
}